import React, { useEffect, useState } from "react";
import "../assets/css/Navbar.css";
import logo from "../assets/img/logo/comparedly-logo.png";
import { useLocation, useNavigate } from "react-router-dom";


const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("");
  const [isScrollingManually, setIsScrollingManually] = useState(false);
  const appFrontendUrl = process.env.REACT_APP_URL;
  const location = useLocation();
  const navigate = useNavigate();


  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    const handleResize = () => {
      if (window.innerWidth > 1024) {
        setMenuOpen(false);
      }
    };

    const observer = new IntersectionObserver(
      (entries) => {
        if (isScrollingManually) return;
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      { threshold: 0.6 } // 60% of section must be visible
    );

    const sections = document.querySelectorAll("section");
    sections.forEach((section) => observer.observe(section));

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
      sections.forEach((section) => observer.unobserve(section));
    };
  }, [menuOpen, isScrollingManually]);

  const handleLinkClick = (event, id) => {
    event.preventDefault();

    if (location.pathname !== "/") {
      // Navigate to homepage and scroll after mount
      navigate("/", { state: { scrollTo: id } });
    } else {
      const section = document.getElementById(id);
      if (section) {
        setIsScrollingManually(true);

        section.scrollIntoView({ behavior: "smooth" });
        setActiveSection(id);
        setMenuOpen(false);

        setTimeout(() => setIsScrollingManually(false), 800);
      }
    }
  };


  const handleLoginClick = (event) => {
    event.preventDefault();
    window.location.href = `${appFrontendUrl}/`;
  };

  return (
    <div className="navbar-wrapper">
      <nav className={`navbar ${scrolled ? "scrolled" : ""}`}>
        <div className="navbar-container">
          {/* Logo and App Name */}
          <a
            href="/"
            className="navbar-brand"
            onClick={(e) => {
              e.preventDefault();
              setMenuOpen(false);
              setActiveSection("");

              if (location.pathname !== "/") {
                navigate("/", { state: { scrollTo: "top" } });
              } else {
                window.scrollTo({ top: 0, behavior: "smooth" });
              }
            }}
          >
            <img src={logo} alt="Comparedly Logo" className="navbar-logo" />
            COMPAREDLY
          </a>


          {/* Hamburger Menu Toggle */}
          <div className={`navbar-toggle ${menuOpen ? "open" : ""}`} onClick={() => setMenuOpen(!menuOpen)}>
            <span></span>
            <span></span>
            <span></span>
          </div>

          {/* Desktop Menu */}
          <div className="navbar-menu">
            <div className="navbar-links">
              <a href="#features" className={`navbar-link ${activeSection === "features" ? "active" : ""}`} onClick={(e) => handleLinkClick(e, "features")}>Features</a>
              <a href="#competitors" className={`navbar-link ${activeSection === "competitors" ? "active" : ""}`} onClick={(e) => handleLinkClick(e, "competitors")}>Competitors</a>
              <a href="#pain-points" className={`navbar-link ${activeSection === "pain-points" ? "active" : ""}`} onClick={(e) => handleLinkClick(e, "pain-points")}>Why Us</a>
              <a href="#pricing" className={`navbar-link ${activeSection === "pricing" ? "active" : ""}`} onClick={(e) => handleLinkClick(e, "pricing")}>Pricing</a>
              <a href="#how-it-works" className={`navbar-link ${activeSection === "how-it-works" ? "active" : ""}`} onClick={(e) => handleLinkClick(e, "how-it-works")}>How it works</a>
              <a href="/blog" className={`navbar-link ${activeSection === "blog" ? "active" : ""}`}>Blog</a>
              <a href="#login" className={`navbar-link ${activeSection === "login" ? "active" : ""}`} onClick={handleLoginClick}>Login</a>
            </div>
          </div>

          {/* Fullscreen Mobile Menu */}
          <div className={`navbar-menu-fullscreen ${menuOpen ? "active" : ""}`}>
            <div className="navbar-links">
              <a href="#features" className={`navbar-link ${activeSection === "features" ? "active" : ""}`} onClick={(e) => handleLinkClick(e, "features")}>Features</a>
              <a href="#competitors" className={`navbar-link ${activeSection === "competitors" ? "active" : ""}`} onClick={(e) => handleLinkClick(e, "competitors")}>Competitors</a>
              <a href="#pain-points" className={`navbar-link ${activeSection === "pain-points" ? "active" : ""}`} onClick={(e) => handleLinkClick(e, "pain-points")}>Why Us</a>
              <a href="#pricing" className={`navbar-link ${activeSection === "pricing" ? "active" : ""}`} onClick={(e) => handleLinkClick(e, "pricing")}>Pricing</a>
              <a href="#how-it-works" className={`navbar-link ${activeSection === "how-it-works" ? "active" : ""}`} onClick={(e) => handleLinkClick(e, "how-it-works")}>How it works</a>
              <a href="/blog" className={`navbar-link ${activeSection === "blog" ? "active" : ""}`}>Blog</a>
              <a href="#login" className={`navbar-link ${activeSection === "login" ? "active" : ""}`} onClick={handleLoginClick}>Login</a>
            </div>
          </div>

          {/* Overlay for Fullscreen Menu */}
          {menuOpen && <div className="navbar-overlay" onClick={() => setMenuOpen(false)}></div>}
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
